import React, {FC} from 'react';
import './style.scss';
import {hardness} from "../../../assets/data/hardnessData";
import {IMixTobaccos} from "../../../constants/types";

interface IMixTotal {
    mixTobaccos: Array<IMixTobaccos>
}

const MixTotal: FC<IMixTotal> = ({mixTobaccos}) => {

    const hardnessMix = Math.round((mixTobaccos
        .map((item: { hardness: number }) => item.hardness)
        .reduce((acc: number, val: number) => acc + val)) / mixTobaccos.length);

    const findHardness: any = hardness
        .find((item: { id: number }) => item.id === hardnessMix);

    return (
        <div className="mix-week-page__total">
            <div className="mix-week-total_row">
                <div className="mix-week-total__title">
                    Крепость
                </div>
                <div className="mix-week-total__text">
                    {findHardness.name}
                </div>
            </div>
            <div className="mix-week-total_row">
                <div className="mix-week-total__title">
                    Приблизительный вес микса
                </div>
                <div className="mix-week-total__text">
                    ≈ 20 гр
                </div>
            </div>
        </div>
    )
};

export default MixTotal;
